import { render } from "./EssaysComponent.vue?vue&type=template&id=65b3d600&ts=true"
import script from "./EssaysComponent.vue?vue&type=script&lang=ts"
export * from "./EssaysComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__